
import Vue from 'vue'

export default Vue.extend({
  name: 'InfoSvg',
  props: {
    color: {
      required: false,
      default: 'currentColor',
      type: String,
    },
  },
})
